import { render, staticRenderFns } from "./DraggableLists.vue?vue&type=template&id=bc3f6aba&scoped=true&"
import script from "./DraggableLists.vue?vue&type=script&lang=js&"
export * from "./DraggableLists.vue?vue&type=script&lang=js&"
import style0 from "./DraggableLists.vue?vue&type=style&index=0&id=bc3f6aba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3f6aba",
  null
  
)

export default component.exports